// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { ReactNode } from 'react';

import type { ViewKind } from '../../bygning/selection';
import { SegmentedControl } from '../SegmentedControl';

/** The v8 prototype's Model / Tabel icons, and Galleri's 2×2 cards. */
const ICON: Record<ViewKind, ReactNode> = {
  model: (
    <>
      <path d="M21 8 12 3 3 8v8l9 5 9-5z" />
      <path d="m3 8 9 5 9-5M12 13v8" />
    </>
  ),
  tabel: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 10h18M3 15h18M9 4v16" />
    </>
  ),
  galleri: (
    <>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
    </>
  ),
};

const LABEL: Record<ViewKind, string> = { model: 'Model', tabel: 'Tabel', galleri: 'Galleri' };
const VIEWS: readonly ViewKind[] = ['model', 'tabel', 'galleri'];

const ITEMS = VIEWS.map((v) => ({
  value: v,
  label: LABEL[v],
  icon: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICON[v]}
    </svg>
  ),
}));

/** Model / Tabel / Galleri: three faces of the same data and the same selection. */
export function ViewSwitch({ view, onChange }: { view: ViewKind; onChange: (view: ViewKind) => void }) {
  return (
    <SegmentedControl
      role="group"
      aria-label="Model, tabel eller galleri"
      iconOnly
      items={ITEMS}
      value={view}
      onChange={onChange}
    />
  );
}
